import { CLING_MELODY_EXERCISES, type ClingMelodyExercise, type ClingPlayMode } from './clingCantaConfig';
import { CLING_EXPLORE_LEVELS, type ClingExploreLevel } from './clingExploreEngine';

export type ClingConfigSongKind = 'exploracion' | 'canto';

export interface ClingConfigSong {
  id: string;
  kind: ClingConfigSongKind;
  title: string;
  subtitle: string;
  stars: number;
  emoji: string;
  /** Gradiente de fondo en la tarjeta (exploración). */
  sceneBg?: string;
  exploreLevel?: ClingExploreLevel;
  exercise?: ClingMelodyExercise;
}

export const CLING_CONFIG_SONGS: ClingConfigSong[] = [
  {
    id: 'explore-cueva-inicial',
    kind: 'exploracion',
    title: 'Cueva de los Cristales',
    subtitle: 'Explora y recoge notas',
    stars: 2,
    emoji: '🗺️',
    sceneBg: 'linear-gradient(145deg, #1e3a5f 0%, #0f766e 55%, #134e4a 100%)',
    exploreLevel: CLING_EXPLORE_LEVELS[0],
  },
  {
    id: 'canto-lucero',
    kind: 'canto',
    title: 'Canción de Cuna Fácil',
    subtitle: 'Brilla lucero — Sol Mi Sol Do',
    stars: 2,
    emoji: '⭐',
    exercise: CLING_MELODY_EXERCISES.find((e) => e.id === 'lucero'),
  },
  {
    id: 'canto-escala-do',
    kind: 'canto',
    title: 'Escalas Divertidas',
    subtitle: 'Escala de Do paso a paso',
    stars: 3,
    emoji: '🎵',
    exercise: CLING_MELODY_EXERCISES.find((e) => e.id === 'escala-do'),
  },
  {
    id: 'canto-sube-baja',
    kind: 'canto',
    title: 'Sube y Baja',
    subtitle: 'Ondas suaves Do Mi Sol',
    stars: 2,
    emoji: '🌊',
    exercise: CLING_MELODY_EXERCISES.find((e) => e.id === 'sube-baja'),
  },
].filter((s) => (s.kind === 'exploracion' ? s.exploreLevel : s.exercise)) as ClingConfigSong[];

export function songSelectionId(mode: ClingPlayMode, exerciseId: string, exploreId: string): string {
  if (mode === 'exploracion') return `explore-${exploreId}`;
  return `canto-${exerciseId}`;
}

export function applyConfigSong(
  song: ClingConfigSong
): { mode: ClingPlayMode; exercise?: ClingMelodyExercise; exploreLevel?: ClingExploreLevel } {
  if (song.kind === 'exploracion' && song.exploreLevel) {
    return { mode: 'exploracion', exploreLevel: song.exploreLevel };
  }
  if (song.exercise) {
    return { mode: 'canto', exercise: song.exercise };
  }
  return { mode: 'exploracion', exploreLevel: CLING_EXPLORE_LEVELS[0] };
}
